import { Card as AntdCard } from "antd";
import { CardProps as AntdCardProps } from "antd/lib/card";
import React, { ReactNode } from "react";

export interface MyCardProps extends AntdCardProps {
  children?: ReactNode;
}

export interface CardStaticMethods {
  Grid: typeof AntdCard.Grid;
  Meta: typeof AntdCard.Meta;
}

const CardPolyfill: React.FC<MyCardProps> & CardStaticMethods = ({
  children,
  ...props
}) => {
  return <AntdCard {...props}>{children}</AntdCard>;
};

CardPolyfill.Grid = AntdCard.Grid;
CardPolyfill.Meta = AntdCard.Meta;

export default CardPolyfill;
